/* Bannière cookies Chamini (RGPD / CNIL), chargée par la section « Bannière cookies Chamini ».
   Le choix est transmis à l'API Shopify Customer Privacy (setTrackingConsent) : Shopify, ses pixels
   et les applis compatibles (dont Facebook & Instagram) le respectent. La date du choix est gardée
   dans le navigateur pour redemander au bout de N mois (réglage de la section, 6 par défaut).
   Expose window.ChaminiCookies = { open(), openPreferences(), getConsent() }
   et l'événement document 'chamini:consent-changed' (detail = choix). */
(function () {
  'use strict';
  if (window.ChaminiCookies && typeof window.ChaminiCookies.openPreferences === 'function') return;

  var root = document.getElementById('ChaminiCc');
  if (!root) return;

  var STORE_KEY = 'chamini_cookie_consent';
  var TEST_KEY = 'chamini_cookies_test';
  var CATEGORIES = ['analytics', 'marketing', 'preferences'];
  /* Pays de l'UE / EEE, plus Royaume-Uni et Suisse : bannière affichée en cas de doute. */
  var EU = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'IS', 'LI', 'NO', 'GB', 'CH',
    'GP', 'MQ', 'GF', 'RE', 'YT', 'MF', 'BL', 'PM'];

  var data = root.dataset || {};
  var enabled = data.enabled === 'true';
  var testMode = data.testMode === 'true';
  var search = window.location.search || '';
  var testParam = testMode && /[?&]cookies-test=1(&|$)/.test(search);
  var testSession = false;
  try {
    if (/[?&]cookies-test=0(&|$)/.test(search)) window.sessionStorage.removeItem(TEST_KEY);
    if (testParam) window.sessionStorage.setItem(TEST_KEY, '1');
    testSession = testMode && window.sessionStorage.getItem(TEST_KEY) === '1';
  } catch (e) { testSession = testParam; }
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var editorPreview = designMode && data.editorPreview === 'true';

  /* Bannière inactive : rien n'est exposé, les autres briques gardent Consentmo. */
  if (!enabled && !testSession && !editorPreview) return;

  var months = parseInt(data.renewMonths, 10);
  if (!(months >= 1 && months <= 24)) months = 6;
  var RENEW_MS = months * 30.44 * 24 * 60 * 60 * 1000;

  var banner = root.querySelector('[data-cc-banner]');
  var panel = root.querySelector('[data-cc-panel]');
  var overlay = root.querySelector('[data-cc-overlay]');
  if (!banner || !panel) return;

  var current = null;        // { analytics, marketing, preferences, date } ou null
  var bannerPending = false; // la bannière attend un choix
  var lastFocus = null;

  /* ---------- Stockage local (date du choix) ---------- */
  function readLocal() {
    try {
      var raw = window.localStorage.getItem(STORE_KEY);
      if (!raw) return null;
      var v = JSON.parse(raw);
      if (!v || typeof v.date !== 'number') return null;
      return { analytics: v.analytics === true, marketing: v.marketing === true, preferences: v.preferences === true, date: v.date };
    } catch (e) { return null; }
  }

  function writeLocal(c) {
    try { window.localStorage.setItem(STORE_KEY, JSON.stringify({ v: 1, date: c.date, analytics: c.analytics, marketing: c.marketing, preferences: c.preferences })); } catch (e) {}
  }

  /* ---------- API Shopify Customer Privacy ---------- */
  function api() {
    var p = window.Shopify && window.Shopify.customerPrivacy;
    return p && typeof p.setTrackingConsent === 'function' ? p : null;
  }

  var apiWaiters = null;
  function loadApi(cb) {
    if (api()) return cb(api());
    if (apiWaiters) { apiWaiters.push(cb); return; }
    apiWaiters = [cb];
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      var list = apiWaiters; apiWaiters = null;
      for (var i = 0; i < list.length; i++) { try { list[i](api()); } catch (e) {} }
    }
    function request() {
      try {
        if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { finish(); });
          return true;
        }
      } catch (e) {}
      return false;
    }
    if (!request()) {
      // loadFeatures absent pour l'instant : nouvel essai au chargement complet
      window.addEventListener('load', function () { if (!request()) finish(); });
    }
    setTimeout(finish, 5000);
  }

  function toBool(v) {
    if (v === 'yes' || v === true) return true;
    if (v === 'no' || v === false) return false;
    return null;
  }

  /* Choix connu de Shopify (cookie _tracking_consent), ou null s'il n'y en a pas. */
  function readShopify(a) {
    if (!a || typeof a.currentVisitorConsent !== 'function') return null;
    try {
      var c = a.currentVisitorConsent() || {};
      var r = { analytics: toBool(c.analytics), marketing: toBool(c.marketing), preferences: toBool(c.preferences) };
      if (r.analytics === null && r.marketing === null && r.preferences === null) return null;
      return r;
    } catch (e) { return null; }
  }

  function inEu(a) {
    var codes = [];
    if (data.country) codes.push(String(data.country).toUpperCase());
    try { if (a && typeof a.getRegion === 'function') { var reg = a.getRegion(); if (reg) codes.push(String(reg).slice(0, 2).toUpperCase()); } } catch (e) {}
    if (!codes.length) return null;
    for (var i = 0; i < codes.length; i++) if (EU.indexOf(codes[i]) !== -1) return true;
    return false;
  }

  function sendToShopify(c, cb) {
    loadApi(function (a) {
      if (!a) { if (cb) cb(false); return; }
      try {
        a.setTrackingConsent({
          analytics: c.analytics,
          marketing: c.marketing,
          preferences: c.preferences,
          sale_of_data: c.marketing
        }, function (resp) { if (cb) cb(!(resp && resp.error)); });
      } catch (e) { if (cb) cb(false); }
    });
  }

  function copy(c) {
    return c ? { analytics: c.analytics, marketing: c.marketing, preferences: c.preferences, sale_of_data: c.marketing, date: c.date } : null;
  }

  function notify() {
    try { document.dispatchEvent(new CustomEvent('chamini:consent-changed', { detail: copy(current) })); } catch (e) {}
  }

  /* ---------- Affichage ---------- */
  function revealLinks() {
    var links = document.querySelectorAll('[data-cookie-preferences]');
    for (var i = 0; i < links.length; i++) {
      links[i].removeAttribute('hidden');
      var wrap = links[i].closest ? links[i].closest('[data-cookie-preferences-wrap]') : null;
      if (wrap) wrap.removeAttribute('hidden');
    }
  }

  function focusEl(el) {
    try { el.focus({ preventScroll: true }); } catch (e) { try { el.focus(); } catch (err) {} }
  }

  function showBanner() {
    bannerPending = true;
    if (!panel.hidden) return;
    banner.hidden = false;
    focusEl(banner);
  }

  function hideBanner() {
    banner.hidden = true;
  }

  function syncSwitches(c) {
    var sw = panel.querySelectorAll('[data-cc-category]');
    for (var i = 0; i < sw.length; i++) {
      var cat = sw[i].getAttribute('data-cc-category');
      sw[i].setAttribute('aria-checked', c && c[cat] ? 'true' : 'false');
    }
  }

  function focusables() {
    var list = panel.querySelectorAll('button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])');
    var out = [];
    for (var i = 0; i < list.length; i++) if (list[i].offsetParent !== null || list[i] === document.activeElement) out.push(list[i]);
    return out;
  }

  function openPanel() {
    if (!panel.hidden) return;
    var active = document.activeElement;
    lastFocus = active && !banner.contains(active) ? active : null;
    syncSwitches(current);
    banner.hidden = true;
    if (overlay) overlay.hidden = false;
    panel.hidden = false;
    document.body.classList.add('chamini-cc-lock');
    var close = panel.querySelector('[data-cc-action="close"]');
    focusEl(close || panel);
  }

  function closePanel(afterChoice) {
    if (panel.hidden) return;
    panel.hidden = true;
    if (overlay) overlay.hidden = true;
    document.body.classList.remove('chamini-cc-lock');
    if (!afterChoice && bannerPending) {
      banner.hidden = false;
      focusEl(banner);
      return;
    }
    if (lastFocus && document.contains(lastFocus)) focusEl(lastFocus);
    lastFocus = null;
  }

  /* ---------- Enregistrement du choix ---------- */
  function save(c) {
    current = { analytics: !!c.analytics, marketing: !!c.marketing, preferences: !!c.preferences, date: Date.now() };
    writeLocal(current);
    bannerPending = false;
    hideBanner();
    closePanel(true);
    // L'événement part après la réponse de Shopify, pour que les autres briques lisent la nouvelle valeur.
    sendToShopify(current, function () { notify(); });
  }

  function choiceFromSwitches() {
    var c = {};
    for (var i = 0; i < CATEGORIES.length; i++) {
      var el = panel.querySelector('[data-cc-category="' + CATEGORIES[i] + '"]');
      c[CATEGORIES[i]] = !!(el && el.getAttribute('aria-checked') === 'true');
    }
    return c;
  }

  function all(value) {
    return { analytics: value, marketing: value, preferences: value };
  }

  /* ---------- Événements ---------- */
  root.addEventListener('click', function (evt) {
    var t = evt.target;
    var btn = t && t.closest ? t.closest('[data-cc-action], [data-cc-category], [data-cc-toggle], [data-cc-locked]') : null;
    if (!btn) {
      if (overlay && t === overlay) closePanel(false);
      return;
    }
    if (btn.hasAttribute('data-cc-category')) {
      btn.setAttribute('aria-checked', btn.getAttribute('aria-checked') === 'true' ? 'false' : 'true');
      return;
    }
    if (btn.hasAttribute('data-cc-locked')) return;
    if (btn.hasAttribute('data-cc-toggle')) {
      var desc = document.getElementById(btn.getAttribute('aria-controls'));
      var open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (desc) desc.hidden = !open;
      return;
    }
    switch (btn.getAttribute('data-cc-action')) {
      case 'accept': save(all(true)); break;
      case 'reject': save(all(false)); break;
      case 'save': save(choiceFromSwitches()); break;
      case 'preferences': openPanel(); break;
      case 'close': closePanel(false); break;
    }
  });

  document.addEventListener('keydown', function (evt) {
    if (panel.hidden) return;
    if (evt.key === 'Escape' || evt.key === 'Esc') {
      evt.preventDefault();
      closePanel(false);
      return;
    }
    if (evt.key === 'Tab') {
      var f = focusables();
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (!panel.contains(document.activeElement)) { evt.preventDefault(); focusEl(first); }
      else if (evt.shiftKey && (document.activeElement === first || document.activeElement === panel)) { evt.preventDefault(); focusEl(last); }
      else if (!evt.shiftKey && document.activeElement === last) { evt.preventDefault(); focusEl(first); }
    }
  });

  /* Liens « Gérer mes cookies » : tout élément portant data-cookie-preferences. */
  document.addEventListener('click', function (evt) {
    var link = evt.target && evt.target.closest ? evt.target.closest('[data-cookie-preferences]') : null;
    if (!link || root.contains(link)) return;
    evt.preventDefault();
    openPanel();
  });

  /* ---------- Décision au chargement ---------- */
  function decide(a) {
    var local = readLocal();
    var fresh = !!(local && Date.now() - local.date < RENEW_MS);
    var known = readShopify(a);

    if (fresh) {
      current = local;
      // Cookie Shopify effacé mais choix local valide : on le retransmet sans redemander.
      if (a && !known) sendToShopify(current);
    } else if (!local && known) {
      // Choix déjà fait (par exemple avec Consentmo) : repris tel quel, le délai démarre maintenant.
      current = { analytics: known.analytics === true, marketing: known.marketing === true, preferences: known.preferences === true, date: Date.now() };
      writeLocal(current);
    }

    // Test (?cookies-test=1) ou aperçu dans l'éditeur : bannière toujours affichée.
    if (testParam || editorPreview) return showBanner();
    if (current) return;
    if (local && !fresh) return showBanner(); // choix trop ancien : on redemande

    var should = null;
    try { if (a && typeof a.shouldShowBanner === 'function') should = !!a.shouldShowBanner(); } catch (e) {}
    var eu = inEu(a);
    // Affichée si Shopify la demande, pour l'UE, ou en cas de doute (pays inconnu).
    if (should === true || eu !== false) showBanner();
  }

  window.ChaminiCookies = {
    open: function () { if (panel.hidden) { banner.hidden = false; focusEl(banner); } },
    openPreferences: function () { openPanel(); return true; },
    getConsent: function () { return copy(current); }
  };

  revealLinks();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', revealLinks);

  // Le contenu n'est pas visible tant que la bannière n'est pas affichée.
  loadApi(decide);

  // Éditeur de thème : affiche la bannière quand la section est sélectionnée.
  if (designMode) {
    document.addEventListener('shopify:section:select', function (evt) {
      if (evt.target && evt.target.contains && evt.target.contains(root)) showBanner();
    });
  }
})();